import React, { useState } from "react";
import { X, Send } from "lucide-react";

const ItemRequestModal = ({
  isOpen,
  onClose,
  qItems,
  onSubmitRequest,
  documentData,
  accountData,
}) => {
  const [requestItems, setRequestItems] = useState(
    qItems.map((item) => ({
      ...item,
      requestedQty: item.qty || 0,
      notes: "",
    }))
  );

  console.log('requestitems', requestItems)

  const handleNotesChange = (index, value) => {
    const updated = [...requestItems];
    updated[index].notes = value;
    setRequestItems(updated);
  };

  const handleSubmit = () => {
    const itemsToRequest = requestItems.filter((item) => item.requestedQty > 0);

    if (itemsToRequest.length === 0) {
      alert("Please enter quantities for at least one item.");
      return;
    }

    onSubmitRequest(itemsToRequest);
  };

  const handleRemoveItem = (index) => {
    const updated = requestItems.filter((_, i) => i !== index);
    setRequestItems(updated);

    if (updated.length === 0) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="bg-white rounded-lg  flex flex-col">
      <div className="bg-gray-50 px-6 py-3 border-b">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="font-medium text-gray-600">Customer:</span>
            <span className="ml-2 text-gray-900">
              {accountData?.accdesc || documentData?.customer || "N/A"}
            </span>
          </div>
          <div>
            <span className="font-medium text-gray-600">Account:</span>
            <span className="ml-2 text-gray-900">
              {accountData?.account || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <div className="flex-1 overflow-auto px-6 py-4">
        <table className="w-full border-collapse">
          <thead className="bg-gray-100 sticky top-0">
            <tr>
              <th className="border px-3 py-2 text-left text-sm font-semibold">
                S.No
              </th>
              <th className="border px-3 py-2 text-left text-sm font-semibold">
                Item Code
              </th>
              <th className="border px-3 py-2 text-left text-sm font-semibold">
                Description
              </th>
              <th className="border px-3 py-2 text-left text-sm font-semibold">
                Unit
              </th>
              <th className="border px-3 py-2 text-right text-sm font-semibold">
                Qty
              </th>
              {/* <th className="border px-3 py-2 text-right text-sm font-semibold">
                Request Qty
              </th> */}
              <th className="border px-3 py-2 text-left text-sm font-semibold">
                Notes
              </th>
              <th className="border px-3 py-2 text-center text-sm font-semibold">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {requestItems.map((item, index) => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="border px-3 py-2 text-sm">{index + 1}</td>
                <td className="border px-3 py-2 text-sm font-medium text-blue-600">
                  {item.code}
                </td>
                <td className="border px-3 py-2 text-sm">{item.description}</td>
                <td className="border px-3 py-2 text-sm">{item.unit}</td>
                <td className="border px-3 py-2 text-sm text-right text-gray-600">
                  {item.qty}
                </td>
                {/* <td className="border px-3 py-2">
                  <input
                    type="number"
                    min="0"
                    value={item.requestedQty}
                    onChange={(e) => handleQtyChange(index, e.target.value)}
                    className="w-full px-2 py-1 border rounded text-sm text-right focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </td> */}
                <td className="border px-3 py-2">
                  <input
                    type="text"
                    value={item.notes}
                    onChange={(e) => handleNotesChange(index, e.target.value)}
                    placeholder="Add notes..."
                    className="w-full px-2 py-1 border rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </td>
                <td className="border px-3 py-2 text-center">
                  <button
                    onClick={() => handleRemoveItem(index)}
                    className="text-red-600 bg-red-100 p-1 rounded transition"
                    title="Remove item"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 px-6 py-4 border-t flex items-center justify-between">
        <div className="text-sm text-gray-600">
          <span className="font-medium">{requestItems.length}</span> item(s) to
          request
        </div>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition text-sm font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition text-sm font-medium"
          >
            <Send className="w-4 h-4" />
            Submit Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemRequestModal;
